(function(){
  function normalizeSize(value){
    var text=String(value||'').toLowerCase().replace(/\s+/g,'').replace(/×/g,'x').replace(/cm/g,'');
    if(text.indexOf('50x70')!==-1)return'50 × 70 cm';
    if(text.indexOf('a4')!==-1)return'A4';
    if(text.indexOf('a3')!==-1)return'A3';
    if(text.indexOf('a2')!==-1)return'A2';
    if(text.indexOf('a1')!==-1)return'A1';
    return String(value||'');
  }
  function finishKey(value){return /lux/i.test(String(value||''))?'lux':'standard';}
  function frameColor(sku,options){
    var key=String(sku||'').split('-').pop().toUpperCase();
    if(key==='NAT')return'natural';
    if(key==='BLK')return'black';
    if(key==='WHT')return'white';
    var joined=(options||[]).join(' ').toLowerCase();
    if(/natur|natural/.test(joined))return'natural';
    if(/schwarz|black/.test(joined))return'black';
    if(/weiß|weiss|white/.test(joined))return'white';
    return'';
  }
  function formatMoney(cents,currency){
    return new Intl.NumberFormat(document.documentElement.lang||'de',{style:'currency',currency:currency}).format(Number(cents||0)/100);
  }
  function option(select,value){
    var item=document.createElement('option');
    item.value=value;
    item.textContent=value;
    select.appendChild(item);
  }
  function createPairId(compositionKey,index){
    var randomPart='';
    if(window.crypto&&typeof window.crypto.randomUUID==='function')randomPart=window.crypto.randomUUID().split('-')[0];
    else randomPart=Math.random().toString(36).slice(2,10);
    return['ML',String(compositionKey).toUpperCase(),Date.now().toString(36).toUpperCase(),String(index+1).padStart(2,'0'),randomPart.toUpperCase()].join('-');
  }
  function buildLineProperties(config,compositionTitle,productTitle,item){
    var poster={
      '_MLineart Gallery Wall':compositionTitle,
      '_MLineart Pair ID':item.pairId,
      '_MLineart Motif':productTitle,
      '_MLineart Print Size':item.size,
      '_MLineart Print Finish':item.finish==='lux'?'LuxTouch Edition':'MLineart Standard'
    };
    poster[config.labels.frameServiceProperty]=item.frame?config.labels[item.color]+' · '+config.labels.readyFramed:config.labels.unframed;
    var frame={
      '_MLineart Gallery Wall':compositionTitle,
      '_MLineart Pair ID':item.pairId,
      '_MLineart Motif':productTitle,
      '_MLineart Frame Size':item.size,
      '_MLineart Frame Colour':item.color
    };
    frame[config.labels.assignedToProperty]=productTitle+' · '+item.size;
    return{poster:poster,frame:frame};
  }
  function init(root){
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var products=JSON.parse(root.querySelector('[data-form-products]').textContent);
    var frames=JSON.parse(root.querySelector('[data-form-frames]').textContent).variants;
    var config=JSON.parse(root.querySelector('[data-form-compositions]').textContent);
    var panel=root.querySelector('[data-configurator]');
    var title=root.querySelector('[data-composition-title]');
    var story=root.querySelector('[data-composition-story]');
    var clarity=root.querySelector('[data-composition-clarity]');
    var image=root.querySelector('[data-composition-image]');
    var sliderViewport=root.querySelector('[data-slider-viewport]');
    var previousSlide=root.querySelector('[data-slider-previous]');
    var nextSlide=root.querySelector('[data-slider-next]');
    var sliderDots=root.querySelector('[data-slider-dots]');
    var sliderNote=root.querySelector('[data-slider-note]');
    var itemsRoot=root.querySelector('[data-composition-items]');
    var presetsRoot=root.querySelector('[data-preset-controls]');
    var designInformation=root.querySelector('[data-design-information]');
    var selectionSummary=root.querySelector('[data-selection-summary]');
    var total=root.querySelector('[data-composition-total]');
    var status=root.querySelector('[data-composition-status]');
    var submit=root.querySelector('[data-composition-submit]');
    var touchStart=null;
    var state={key:'',preset:0,slide:0,items:[]};
    function posterVariant(product,size,finish){
      return product.variants.find(function(variant){return variant.available&&normalizeSize(variant.options[0])===size&&finishKey(variant.options[1])===finish;});
    }
    function matchingFrame(size,color){
      return frames.find(function(variant){return variant.available&&normalizeSize(variant.options.join(' '))===size&&frameColor(variant.sku,variant.options)===color;});
    }
    function activeSlides(composition,preset){
      return Array.isArray(composition.slides)&&composition.slides.length?composition.slides:[preset.image];
    }
    function renderSlider(composition,preset){
      var slides=activeSlides(composition,preset);
      if(state.slide>=slides.length)state.slide=0;
      image.src=slides[state.slide];
      image.alt=composition.title+' — '+config.labels.slide+' '+String(state.slide+1)+'/'+String(slides.length);
      previousSlide.hidden=slides.length<2;
      nextSlide.hidden=slides.length<2;
      sliderDots.hidden=slides.length<2;
      sliderNote.hidden=slides.length<2;
      sliderDots.innerHTML='';
      slides.forEach(function(unused,index){
        var dot=document.createElement('button');
        dot.type='button';
        dot.className='form-gallery-slider__dot';
        dot.setAttribute('aria-label',config.labels.slide+' '+String(index+1));
        dot.setAttribute('aria-current',String(index===state.slide));
        dot.addEventListener('click',function(){state.slide=index;renderSlider(composition,preset);});
        sliderDots.appendChild(dot);
      });
    }
    function moveSlide(direction){
      var composition=config.items[state.key];
      if(!composition)return;
      var preset=composition.presets[state.preset]||composition.presets[0];
      var slides=activeSlides(composition,preset);
      if(slides.length<2)return;
      state.slide=(state.slide+direction+slides.length)%slides.length;
      renderSlider(composition,preset);
    }
    function renderPresetButtons(composition){
      presetsRoot.innerHTML='';
      presetsRoot.hidden=composition.presets.length<2;
      composition.presets.forEach(function(preset,index){
        var button=document.createElement('button');
        button.type='button';
        button.textContent=(index===0?config.labels.presetA:config.labels.presetB)+' · '+preset.sizes.join(' + ');
        button.setAttribute('aria-pressed',String(index===state.preset));
        button.addEventListener('click',function(){state.preset=index;state.slide=0;render();});
        presetsRoot.appendChild(button);
      });
    }
    function renderDesignInformation(composition){
      designInformation.innerHTML='';
      var lead=document.createElement('p');
      lead.textContent=composition.story;
      designInformation.appendChild(lead);
      var links=document.createElement('ul');
      links.className='form-gallery-accordion__design-links';
      composition.products.forEach(function(handle){
        var product=products[handle];
        var item=document.createElement('li');
        var link=document.createElement('a');
        link.href=product.url;
        link.textContent=product.title+' — '+config.labels.viewDesign;
        item.appendChild(link);
        links.appendChild(item);
      });
      designInformation.appendChild(links);
      var series=document.createElement('p');
      series.textContent=config.labels.series;
      designInformation.appendChild(series);
    }
    function createField(labelText,className){
      var label=document.createElement('label');
      label.className='form-gallery-configurator__field '+(className||'');
      var text=document.createElement('span');
      text.textContent=labelText;
      label.appendChild(text);
      return label;
    }
    function render(){
      var composition=config.items[state.key];
      if(!composition)return;
      var preset=composition.presets[state.preset]||composition.presets[0];
      title.textContent=composition.title;
      story.textContent=composition.story.split('.')[0]+'.';
      clarity.textContent=composition.products.length+' '+config.labels.posters+' · '+preset.sizes.join(' + ');
      renderSlider(composition,preset);
      renderPresetButtons(composition);
      renderDesignInformation(composition);
      itemsRoot.innerHTML='';
      state.items=[];
      composition.products.forEach(function(handle,index){
        var product=products[handle];
        var item={handle:handle,size:preset.sizes[index],finish:'standard',frame:false,color:'natural',pairId:createPairId(state.key,index)};
        state.items.push(item);
        var card=document.createElement('article');
        card.className='form-gallery-configurator__item';
        var thumb=document.createElement('img');
        thumb.src=product.image;
        thumb.alt=product.title;
        thumb.loading='lazy';
        card.appendChild(thumb);
        var body=document.createElement('div');
        var head=document.createElement('div');
        head.className='form-gallery-configurator__item-head';
        var name=document.createElement('strong');
        name.textContent=String(index+1).padStart(2,'0')+' '+product.title;
        var price=document.createElement('span');
        price.className='form-gallery-configurator__item-price';
        price.dataset.itemPrice=String(index);
        head.appendChild(name);
        head.appendChild(price);
        body.appendChild(head);
        var fields=document.createElement('div');
        fields.className='form-gallery-configurator__fields';
        var sizeField=createField(config.labels.size);
        var sizeSelect=document.createElement('select');
        ['A4','A3','A2','A1','50 × 70 cm'].forEach(function(value){option(sizeSelect,value);});
        sizeSelect.value=item.size;
        sizeSelect.addEventListener('change',function(){item.size=this.value;updatePrices();});
        sizeField.appendChild(sizeSelect);
        fields.appendChild(sizeField);
        var finishField=createField(config.labels.finish);
        var finishSelect=document.createElement('select');
        option(finishSelect,'MLineart Standard');
        option(finishSelect,'LuxTouch Edition');
        finishSelect.addEventListener('change',function(){item.finish=finishKey(this.value);updatePrices();});
        finishField.appendChild(finishSelect);
        fields.appendChild(finishField);
        var frameField=createField(config.labels.frame,'form-gallery-configurator__field--frame');
        var frameToggle=document.createElement('label');
        frameToggle.className='form-gallery-configurator__frame-toggle';
        var frameCheckbox=document.createElement('input');
        frameCheckbox.type='checkbox';
        var frameText=document.createElement('span');
        frameText.textContent=config.labels.addFrame;
        frameToggle.appendChild(frameCheckbox);
        frameToggle.appendChild(frameText);
        frameField.appendChild(frameToggle);
        var colorSelect=document.createElement('select');
        colorSelect.className='form-gallery-configurator__frame-color';
        colorSelect.hidden=true;
        option(colorSelect,'natural');
        option(colorSelect,'black');
        option(colorSelect,'white');
        Array.prototype.forEach.call(colorSelect.options,function(colorOption){colorOption.textContent=config.labels[colorOption.value];});
        colorSelect.addEventListener('change',function(){item.color=this.value;updatePrices();});
        frameField.appendChild(colorSelect);
        var frameService=document.createElement('span');
        frameService.className='form-gallery-configurator__frame-service';
        frameService.textContent=config.labels.frameService;
        frameField.appendChild(frameService);
        frameCheckbox.addEventListener('change',function(){item.frame=this.checked;colorSelect.hidden=!item.frame;updatePrices();});
        fields.appendChild(frameField);
        body.appendChild(fields);
        card.appendChild(body);
        itemsRoot.appendChild(card);
      });
      submit.textContent=composition.products.length===2?config.labels.twoCart:config.labels.threeCart;
      status.textContent='';
      updatePrices();
    }
    function selection(){
      var lines=[];
      var cents=0;
      var invalid=false;
      var framesSelected=0;
      state.items.forEach(function(item,index){
        var product=products[item.handle];
        var poster=posterVariant(product,item.size,item.finish);
        var priceNode=root.querySelector('[data-item-price="'+index+'"]');
        if(!poster){invalid=true;if(priceNode)priceNode.textContent='—';return;}
        var frame=null;
        if(item.frame){
          frame=matchingFrame(item.size,item.color);
          if(!frame){invalid=true;return;}
        }
        var properties=buildLineProperties(config,config.items[state.key].title,product.title,item);
        cents+=poster.price;
        lines.push({id:Number(poster.id),quantity:1,properties:properties.poster});
        if(item.frame){
          cents+=frame.price;
          framesSelected+=1;
          lines.push({id:Number(frame.id),quantity:1,properties:properties.frame});
        }
        if(priceNode)priceNode.textContent=formatMoney(poster.price+(item.frame?(matchingFrame(item.size,item.color)||{price:0}).price:0),config.currency);
      });
      return{lines:lines,cents:cents,invalid:invalid,posters:state.items.length,frames:framesSelected};
    }
    function updateSelectionSummary(current){
      var values={posters:current.posters,frames:current.frames,unframed:current.posters-current.frames};
      function fill(template){
        return String(template).replace(/\{(posters|frames|unframed)\}/g,function(unused,key){return String(values[key]);});
      }
      if(current.frames===0){
        selectionSummary.textContent=fill(config.labels.summaryNoFrames);
        return;
      }
      if(current.frames===current.posters){
        selectionSummary.textContent=fill(config.labels.summaryAllFramed);
        return;
      }
      selectionSummary.textContent=fill(current.posters-current.frames===1?config.labels.summaryPartiallyFramedOne:config.labels.summaryPartiallyFramedMany);
    }
    function updatePrices(){
      var current=selection();
      total.textContent=current.invalid?'—':formatMoney(current.cents,config.currency);
      submit.disabled=current.invalid;
      updateSelectionSummary(current);
    }
    function open(key){
      state.key=key;
      state.preset=0;
      state.slide=0;
      panel.hidden=false;
      render();
      panel.scrollIntoView({behavior:'smooth',block:'start'});
    }
    previousSlide.addEventListener('click',function(){moveSlide(-1);});
    nextSlide.addEventListener('click',function(){moveSlide(1);});
    sliderViewport.addEventListener('touchstart',function(event){
      if(!event.changedTouches.length)return;
      touchStart={x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY};
    },{passive:true});
    sliderViewport.addEventListener('touchend',function(event){
      if(!touchStart||!event.changedTouches.length)return;
      var dx=event.changedTouches[0].clientX-touchStart.x;
      var dy=event.changedTouches[0].clientY-touchStart.y;
      touchStart=null;
      if(Math.abs(dx)>44&&Math.abs(dx)>Math.abs(dy))moveSlide(dx<0?1:-1);
    },{passive:true});
    root.querySelectorAll('[data-composition-card]').forEach(function(card){card.addEventListener('click',function(){open(this.dataset.compositionCard);});});
    root.querySelector('[data-configurator-close]').addEventListener('click',function(){panel.hidden=true;});
    submit.addEventListener('click',function(){
      var current=selection();
      if(current.invalid||!current.lines.length)return;
      submit.setAttribute('aria-busy','true');
      submit.disabled=true;
      status.textContent='';
      var rootPath=window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/';
      fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:current.lines})})
        .then(function(response){if(!response.ok)return response.json().then(function(body){throw new Error(body.description||config.labels.error);});return response.json();})
        .then(function(payload){
          status.textContent=config.labels.added;
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart:payload}}));
          window.location.href=rootPath+'cart';
        })
        .catch(function(error){status.textContent=error.message||config.labels.error;submit.disabled=false;})
        .finally(function(){submit.removeAttribute('aria-busy');});
    });
  }
  function start(){document.querySelectorAll('[data-form-gallery-commerce]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
